import { defineFeature } from '@/lib/platform/system';
import { hiveMachine } from '@/features/hive/state/hive.machine';

export const features = [
  defineFeature({
    id: 'hive',
    machine: hiveMachine,
    emits: ['hive.registered'],
    handles: [],
    accepts: ['hive.load-hives', 'hive.open-register', 'hive.register'],
  }),
] as const;
